import { z } from "zod";

export const getLoginSchema = () => {
  return z.object({
    username: z.string().min(1, ""),
    password: z.string().min(1, ""),
  });
};

export type LoginSchema = z.infer<ReturnType<typeof getLoginSchema>>;
